import React from "react";

export default function MessageErrorComponent({
    messageError,
}: {
    messageError: string;
}): JSX.Element {
    return (
        <div
            style={{
                width: "100%",
                marginTop: "0.25rem",
                fontSize: "18px",
                fontWeight: 500,
                color: "#f46a6a",
                padding: "0.5rem 0",
            }}
        >
            {messageError}
        </div>
    );
}
